import { render, staticRenderFns } from "./ClassicTimeDimensionsTab.vue?vue&type=template&id=771c9247&"
import script from "./ClassicTimeDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicTimeDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports